import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { isNumber } from "util";
import { addToCart, confirmCartItems } from "../../store/cart";
import { changeProductQuantity } from "../../store/product";
import shop from "../../api/shop";
import debounce from "lodash/debounce";

const BuyingForm = ({
  disabled,
  index,
  title,
  productId,
  quantity,
  onSubmit,
  changeProductQuantity,
  saveCartQuantity,
  customer,
  actionBar,
  ozPrice,
  labelQnt,
  confirmCartItems
}) => {
  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        onSubmit(e.target.querySelector("input").value, productId);
        // saveCartQuantity(
        //   e.target.querySelector("input").value,
        //   productId,
        //   customer,
        //   ozPrice
        // );
      }}
    >
      <div className="productBox__footer__buy">
        <input
          type="number"
          min="1"
          value={!quantity ? "" : quantity}
          onChange={e => {
            changeProductQuantity(e.target.value, productId);
            e.stopPropagation();
          }}
          placeholder={labelQnt}
          aria-label="Quantity"
          aria-describedby="quantity"
          tabIndex={index}
          disabled={disabled}
        />
        <button
          tabIndex="-1"
          className="productBox__footer__buy__button"
          type="submit"
          disabled={disabled}
          onClick={e =>
            confirmCartItems(productId, customer, ozPrice, actionBar)
          }
        >
          {title}
        </button>
      </div>
    </form>
  );
};
BuyingForm.propTypes = {
  productId: PropTypes.number,
  title: PropTypes.string.isRequired,
  quantity: PropTypes.number,
  onSubmit: PropTypes.func.isRequired,
  index: PropTypes.number,
  changeProductQuantity: PropTypes.func,
  saveCartQuantity: PropTypes.func,
  customer: PropTypes.number,
  actionBar: PropTypes.string,
  ozPrice: PropTypes.number,
  labelQnt: PropTypes.string
};

const mapStateToProps = ({ common, customer }) => ({
  customer: common.user.personal.id,
  actionBar: customer.actionOnCustomer
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (value, productId, orderType) => {
    dispatch(addToCart(productId, value));
  },
  changeProductQuantity: (val, productId) => {
    if (isNumber(parseInt(val))) {
      dispatch(changeProductQuantity(productId, parseInt(val)));
    }
  },
  saveCartQuantity: (val, productId, customer, ozPrice) => {
    // if (isNumber(parseInt(val))) {
    //   shop.addCartItem(
    //     {
    //       product: productId,
    //       quantity: val === "" ? 1 : parseInt(val, 10),
    //       customer_id: customer,
    //       ozPrice: parseFloat(ozPrice)
    //     },
    //     cartItemFromApi => {
    //       cartItemFromApi.then(cartItem => {
    //         console.log("item changed:");
    //         console.log(cartItem);
    //       });
    //     },
    //     0
    //   );
    // }
  },
  confirmCartItems: debounce((productId, customer, ozPrice, actionBar) => {
    console.log("confirm items for product: " + productId);
    dispatch(
      confirmCartItems(productId, customer, ozPrice.toString(), actionBar)
    );
  }, 1000)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuyingForm);



// WEBPACK FOOTER //
// ./src/molecules/containers/BuyingForm.js